"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/order/v1/portal_service.proto (package spwn.order.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalOrderServiceMarkCartNotificationsAsReadResponse = exports.PortalOrderServiceMarkCartNotificationsAsReadRequest = exports.PortalOrderServiceGetCartsNotificationsResponse = exports.PortalOrderServiceGetCartsNotificationsRequest = exports.PortalOrderServiceCancelOrderResponse = exports.PortalOrderServiceCancelOrderRequest = exports.PortalOrderServiceGetOrdersByGoodsIdResponse = exports.PortalOrderServiceGetOrdersByGoodsIdRequest = exports.PortalOrderServiceUpdateCartItemResponse = exports.PortalOrderServiceUpdateCartItemRequest = exports.PortalOrderServiceGetCartResponse = exports.PortalOrderServiceGetCartRequest = exports.PortalOrderServiceGetCartsResponse = exports.PortalOrderServiceGetCartsRequest = exports.PortalOrderServiceStartCheckoutSessionFromCartResponse = exports.PortalOrderServiceStartCheckoutSessionFromCartRequest_PortalOrderPaymentMethod = exports.PortalOrderServiceStartCheckoutSessionFromCartRequest = exports.PortalOrderServiceGetOrdersByBrandFirestoreIdResponse = exports.PortalOrderServiceGetOrdersByBrandFirestoreIdRequest_PortalOrderIncludedItemType = exports.PortalOrderServiceGetOrdersByBrandFirestoreIdRequest = exports.PortalOrderServiceGetOrderResponse = exports.PortalOrderServiceGetOrderRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const portal_common_pb_1 = require("./portal_common_pb");
/**
 * @generated from message spwn.order.v1.PortalOrderServiceGetOrderRequest
 */
class PortalOrderServiceGetOrderRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_firestore_id = 1;
         */
        this.orderFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceGetOrderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceGetOrderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceGetOrderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceGetOrderRequest, a, b);
    }
}
exports.PortalOrderServiceGetOrderRequest = PortalOrderServiceGetOrderRequest;
PortalOrderServiceGetOrderRequest.runtime = protobuf_1.proto3;
PortalOrderServiceGetOrderRequest.typeName = "spwn.order.v1.PortalOrderServiceGetOrderRequest";
PortalOrderServiceGetOrderRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceGetOrderResponse
 */
class PortalOrderServiceGetOrderResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceGetOrderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceGetOrderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceGetOrderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceGetOrderResponse, a, b);
    }
}
exports.PortalOrderServiceGetOrderResponse = PortalOrderServiceGetOrderResponse;
PortalOrderServiceGetOrderResponse.runtime = protobuf_1.proto3;
PortalOrderServiceGetOrderResponse.typeName = "spwn.order.v1.PortalOrderServiceGetOrderResponse";
PortalOrderServiceGetOrderResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order", kind: "message", T: portal_common_pb_1.PortalOrder },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceGetOrdersByBrandFirestoreIdRequest
 */
class PortalOrderServiceGetOrdersByBrandFirestoreIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_firestore_id = 1;
         */
        this.brandFirestoreId = "";
        /**
         * @generated from field: repeated spwn.order.v1.PortalOrderServiceGetOrdersByBrandFirestoreIdRequest.PortalOrderIncludedItemType included_item_type = 2;
         */
        this.includedItemType = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceGetOrdersByBrandFirestoreIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceGetOrdersByBrandFirestoreIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceGetOrdersByBrandFirestoreIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceGetOrdersByBrandFirestoreIdRequest, a, b);
    }
}
exports.PortalOrderServiceGetOrdersByBrandFirestoreIdRequest = PortalOrderServiceGetOrdersByBrandFirestoreIdRequest;
PortalOrderServiceGetOrdersByBrandFirestoreIdRequest.runtime = protobuf_1.proto3;
PortalOrderServiceGetOrdersByBrandFirestoreIdRequest.typeName = "spwn.order.v1.PortalOrderServiceGetOrdersByBrandFirestoreIdRequest";
PortalOrderServiceGetOrdersByBrandFirestoreIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "included_item_type", kind: "enum", T: protobuf_1.proto3.getEnumType(PortalOrderServiceGetOrdersByBrandFirestoreIdRequest_PortalOrderIncludedItemType), repeated: true },
]);
/**
 * @generated from enum spwn.order.v1.PortalOrderServiceGetOrdersByBrandFirestoreIdRequest.PortalOrderIncludedItemType
 */
var PortalOrderServiceGetOrdersByBrandFirestoreIdRequest_PortalOrderIncludedItemType;
(function (PortalOrderServiceGetOrdersByBrandFirestoreIdRequest_PortalOrderIncludedItemType) {
    /**
     * @generated from enum value: PORTAL_ORDER_INCLUDED_ITEM_TYPE_UNSPECIFIED = 0;
     */
    PortalOrderServiceGetOrdersByBrandFirestoreIdRequest_PortalOrderIncludedItemType[PortalOrderServiceGetOrdersByBrandFirestoreIdRequest_PortalOrderIncludedItemType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: PORTAL_ORDER_INCLUDED_ITEM_TYPE_PLAN = 1;
     */
    PortalOrderServiceGetOrdersByBrandFirestoreIdRequest_PortalOrderIncludedItemType[PortalOrderServiceGetOrdersByBrandFirestoreIdRequest_PortalOrderIncludedItemType["PLAN"] = 1] = "PLAN";
    /**
     * @generated from enum value: PORTAL_ORDER_INCLUDED_ITEM_TYPE_GOODS = 2;
     */
    PortalOrderServiceGetOrdersByBrandFirestoreIdRequest_PortalOrderIncludedItemType[PortalOrderServiceGetOrdersByBrandFirestoreIdRequest_PortalOrderIncludedItemType["GOODS"] = 2] = "GOODS";
})(PortalOrderServiceGetOrdersByBrandFirestoreIdRequest_PortalOrderIncludedItemType = exports.PortalOrderServiceGetOrdersByBrandFirestoreIdRequest_PortalOrderIncludedItemType || (exports.PortalOrderServiceGetOrdersByBrandFirestoreIdRequest_PortalOrderIncludedItemType = {}));
// Retrieve enum metadata with: proto3.getEnumType(PortalOrderServiceGetOrdersByBrandFirestoreIdRequest_PortalOrderIncludedItemType)
protobuf_1.proto3.util.setEnumType(PortalOrderServiceGetOrdersByBrandFirestoreIdRequest_PortalOrderIncludedItemType, "spwn.order.v1.PortalOrderServiceGetOrdersByBrandFirestoreIdRequest.PortalOrderIncludedItemType", [
    { no: 0, name: "PORTAL_ORDER_INCLUDED_ITEM_TYPE_UNSPECIFIED" },
    { no: 1, name: "PORTAL_ORDER_INCLUDED_ITEM_TYPE_PLAN" },
    { no: 2, name: "PORTAL_ORDER_INCLUDED_ITEM_TYPE_GOODS" },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceGetOrdersByBrandFirestoreIdResponse
 */
class PortalOrderServiceGetOrdersByBrandFirestoreIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.order.v1.PortalOrder orders = 1;
         */
        this.orders = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceGetOrdersByBrandFirestoreIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceGetOrdersByBrandFirestoreIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceGetOrdersByBrandFirestoreIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceGetOrdersByBrandFirestoreIdResponse, a, b);
    }
}
exports.PortalOrderServiceGetOrdersByBrandFirestoreIdResponse = PortalOrderServiceGetOrdersByBrandFirestoreIdResponse;
PortalOrderServiceGetOrdersByBrandFirestoreIdResponse.runtime = protobuf_1.proto3;
PortalOrderServiceGetOrdersByBrandFirestoreIdResponse.typeName = "spwn.order.v1.PortalOrderServiceGetOrdersByBrandFirestoreIdResponse";
PortalOrderServiceGetOrdersByBrandFirestoreIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "orders", kind: "message", T: portal_common_pb_1.PortalOrder, repeated: true },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceStartCheckoutSessionFromCartRequest
 */
class PortalOrderServiceStartCheckoutSessionFromCartRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string cart_id = 1;
         */
        this.cartId = "";
        /**
         * @generated from field: string address_id = 2;
         */
        this.addressId = "";
        /**
         * @generated from field: spwn.order.v1.PortalOrderServiceStartCheckoutSessionFromCartRequest.PortalOrderPaymentMethod payment_method = 3;
         */
        this.paymentMethod = PortalOrderServiceStartCheckoutSessionFromCartRequest_PortalOrderPaymentMethod.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceStartCheckoutSessionFromCartRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceStartCheckoutSessionFromCartRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceStartCheckoutSessionFromCartRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceStartCheckoutSessionFromCartRequest, a, b);
    }
}
exports.PortalOrderServiceStartCheckoutSessionFromCartRequest = PortalOrderServiceStartCheckoutSessionFromCartRequest;
PortalOrderServiceStartCheckoutSessionFromCartRequest.runtime = protobuf_1.proto3;
PortalOrderServiceStartCheckoutSessionFromCartRequest.typeName = "spwn.order.v1.PortalOrderServiceStartCheckoutSessionFromCartRequest";
PortalOrderServiceStartCheckoutSessionFromCartRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "cart_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "payment_method", kind: "enum", T: protobuf_1.proto3.getEnumType(PortalOrderServiceStartCheckoutSessionFromCartRequest_PortalOrderPaymentMethod) },
]);
/**
 * @generated from enum spwn.order.v1.PortalOrderServiceStartCheckoutSessionFromCartRequest.PortalOrderPaymentMethod
 */
var PortalOrderServiceStartCheckoutSessionFromCartRequest_PortalOrderPaymentMethod;
(function (PortalOrderServiceStartCheckoutSessionFromCartRequest_PortalOrderPaymentMethod) {
    /**
     * @generated from enum value: PORTAL_ORDER_PAYMENT_METHOD_UNSPECIFIED = 0;
     */
    PortalOrderServiceStartCheckoutSessionFromCartRequest_PortalOrderPaymentMethod[PortalOrderServiceStartCheckoutSessionFromCartRequest_PortalOrderPaymentMethod["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: PORTAL_ORDER_PAYMENT_METHOD_CARD = 1;
     */
    PortalOrderServiceStartCheckoutSessionFromCartRequest_PortalOrderPaymentMethod[PortalOrderServiceStartCheckoutSessionFromCartRequest_PortalOrderPaymentMethod["CARD"] = 1] = "CARD";
    /**
     * @generated from enum value: PORTAL_ORDER_PAYMENT_METHOD_KONBINI = 2;
     */
    PortalOrderServiceStartCheckoutSessionFromCartRequest_PortalOrderPaymentMethod[PortalOrderServiceStartCheckoutSessionFromCartRequest_PortalOrderPaymentMethod["KONBINI"] = 2] = "KONBINI";
})(PortalOrderServiceStartCheckoutSessionFromCartRequest_PortalOrderPaymentMethod = exports.PortalOrderServiceStartCheckoutSessionFromCartRequest_PortalOrderPaymentMethod || (exports.PortalOrderServiceStartCheckoutSessionFromCartRequest_PortalOrderPaymentMethod = {}));
// Retrieve enum metadata with: proto3.getEnumType(PortalOrderServiceStartCheckoutSessionFromCartRequest_PortalOrderPaymentMethod)
protobuf_1.proto3.util.setEnumType(PortalOrderServiceStartCheckoutSessionFromCartRequest_PortalOrderPaymentMethod, "spwn.order.v1.PortalOrderServiceStartCheckoutSessionFromCartRequest.PortalOrderPaymentMethod", [
    { no: 0, name: "PORTAL_ORDER_PAYMENT_METHOD_UNSPECIFIED" },
    { no: 1, name: "PORTAL_ORDER_PAYMENT_METHOD_CARD" },
    { no: 2, name: "PORTAL_ORDER_PAYMENT_METHOD_KONBINI" },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceStartCheckoutSessionFromCartResponse
 */
class PortalOrderServiceStartCheckoutSessionFromCartResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string checkout_session_url = 1;
         */
        this.checkoutSessionUrl = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceStartCheckoutSessionFromCartResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceStartCheckoutSessionFromCartResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceStartCheckoutSessionFromCartResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceStartCheckoutSessionFromCartResponse, a, b);
    }
}
exports.PortalOrderServiceStartCheckoutSessionFromCartResponse = PortalOrderServiceStartCheckoutSessionFromCartResponse;
PortalOrderServiceStartCheckoutSessionFromCartResponse.runtime = protobuf_1.proto3;
PortalOrderServiceStartCheckoutSessionFromCartResponse.typeName = "spwn.order.v1.PortalOrderServiceStartCheckoutSessionFromCartResponse";
PortalOrderServiceStartCheckoutSessionFromCartResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "checkout_session_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceGetCartsRequest
 */
class PortalOrderServiceGetCartsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceGetCartsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceGetCartsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceGetCartsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceGetCartsRequest, a, b);
    }
}
exports.PortalOrderServiceGetCartsRequest = PortalOrderServiceGetCartsRequest;
PortalOrderServiceGetCartsRequest.runtime = protobuf_1.proto3;
PortalOrderServiceGetCartsRequest.typeName = "spwn.order.v1.PortalOrderServiceGetCartsRequest";
PortalOrderServiceGetCartsRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceGetCartsResponse
 */
class PortalOrderServiceGetCartsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.order.v1.PortalOrderCart carts = 1;
         */
        this.carts = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceGetCartsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceGetCartsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceGetCartsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceGetCartsResponse, a, b);
    }
}
exports.PortalOrderServiceGetCartsResponse = PortalOrderServiceGetCartsResponse;
PortalOrderServiceGetCartsResponse.runtime = protobuf_1.proto3;
PortalOrderServiceGetCartsResponse.typeName = "spwn.order.v1.PortalOrderServiceGetCartsResponse";
PortalOrderServiceGetCartsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "carts", kind: "message", T: portal_common_pb_1.PortalOrderCart, repeated: true },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceGetCartRequest
 */
class PortalOrderServiceGetCartRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string cart_id = 1;
         */
        this.cartId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceGetCartRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceGetCartRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceGetCartRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceGetCartRequest, a, b);
    }
}
exports.PortalOrderServiceGetCartRequest = PortalOrderServiceGetCartRequest;
PortalOrderServiceGetCartRequest.runtime = protobuf_1.proto3;
PortalOrderServiceGetCartRequest.typeName = "spwn.order.v1.PortalOrderServiceGetCartRequest";
PortalOrderServiceGetCartRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "cart_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceGetCartResponse
 */
class PortalOrderServiceGetCartResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceGetCartResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceGetCartResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceGetCartResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceGetCartResponse, a, b);
    }
}
exports.PortalOrderServiceGetCartResponse = PortalOrderServiceGetCartResponse;
PortalOrderServiceGetCartResponse.runtime = protobuf_1.proto3;
PortalOrderServiceGetCartResponse.typeName = "spwn.order.v1.PortalOrderServiceGetCartResponse";
PortalOrderServiceGetCartResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "cart", kind: "message", T: portal_common_pb_1.PortalOrderCart },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceUpdateCartItemRequest
 */
class PortalOrderServiceUpdateCartItemRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_variant_id = 1;
         */
        this.goodsVariantId = "";
        /**
         * @generated from field: int32 quantity = 2;
         */
        this.quantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceUpdateCartItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceUpdateCartItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceUpdateCartItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceUpdateCartItemRequest, a, b);
    }
}
exports.PortalOrderServiceUpdateCartItemRequest = PortalOrderServiceUpdateCartItemRequest;
PortalOrderServiceUpdateCartItemRequest.runtime = protobuf_1.proto3;
PortalOrderServiceUpdateCartItemRequest.typeName = "spwn.order.v1.PortalOrderServiceUpdateCartItemRequest";
PortalOrderServiceUpdateCartItemRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceUpdateCartItemResponse
 */
class PortalOrderServiceUpdateCartItemResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceUpdateCartItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceUpdateCartItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceUpdateCartItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceUpdateCartItemResponse, a, b);
    }
}
exports.PortalOrderServiceUpdateCartItemResponse = PortalOrderServiceUpdateCartItemResponse;
PortalOrderServiceUpdateCartItemResponse.runtime = protobuf_1.proto3;
PortalOrderServiceUpdateCartItemResponse.typeName = "spwn.order.v1.PortalOrderServiceUpdateCartItemResponse";
PortalOrderServiceUpdateCartItemResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "cart", kind: "message", T: portal_common_pb_1.PortalOrderCart },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceGetOrdersByGoodsIdRequest
 */
class PortalOrderServiceGetOrdersByGoodsIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceGetOrdersByGoodsIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceGetOrdersByGoodsIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceGetOrdersByGoodsIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceGetOrdersByGoodsIdRequest, a, b);
    }
}
exports.PortalOrderServiceGetOrdersByGoodsIdRequest = PortalOrderServiceGetOrdersByGoodsIdRequest;
PortalOrderServiceGetOrdersByGoodsIdRequest.runtime = protobuf_1.proto3;
PortalOrderServiceGetOrdersByGoodsIdRequest.typeName = "spwn.order.v1.PortalOrderServiceGetOrdersByGoodsIdRequest";
PortalOrderServiceGetOrdersByGoodsIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceGetOrdersByGoodsIdResponse
 */
class PortalOrderServiceGetOrdersByGoodsIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.order.v1.PortalOrder orders = 1;
         */
        this.orders = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceGetOrdersByGoodsIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceGetOrdersByGoodsIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceGetOrdersByGoodsIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceGetOrdersByGoodsIdResponse, a, b);
    }
}
exports.PortalOrderServiceGetOrdersByGoodsIdResponse = PortalOrderServiceGetOrdersByGoodsIdResponse;
PortalOrderServiceGetOrdersByGoodsIdResponse.runtime = protobuf_1.proto3;
PortalOrderServiceGetOrdersByGoodsIdResponse.typeName = "spwn.order.v1.PortalOrderServiceGetOrdersByGoodsIdResponse";
PortalOrderServiceGetOrdersByGoodsIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "orders", kind: "message", T: portal_common_pb_1.PortalOrder, repeated: true },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceCancelOrderRequest
 */
class PortalOrderServiceCancelOrderRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_id = 1;
         */
        this.orderId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceCancelOrderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceCancelOrderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceCancelOrderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceCancelOrderRequest, a, b);
    }
}
exports.PortalOrderServiceCancelOrderRequest = PortalOrderServiceCancelOrderRequest;
PortalOrderServiceCancelOrderRequest.runtime = protobuf_1.proto3;
PortalOrderServiceCancelOrderRequest.typeName = "spwn.order.v1.PortalOrderServiceCancelOrderRequest";
PortalOrderServiceCancelOrderRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceCancelOrderResponse
 */
class PortalOrderServiceCancelOrderResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceCancelOrderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceCancelOrderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceCancelOrderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceCancelOrderResponse, a, b);
    }
}
exports.PortalOrderServiceCancelOrderResponse = PortalOrderServiceCancelOrderResponse;
PortalOrderServiceCancelOrderResponse.runtime = protobuf_1.proto3;
PortalOrderServiceCancelOrderResponse.typeName = "spwn.order.v1.PortalOrderServiceCancelOrderResponse";
PortalOrderServiceCancelOrderResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order", kind: "message", T: portal_common_pb_1.PortalOrder },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceGetCartsNotificationsRequest
 */
class PortalOrderServiceGetCartsNotificationsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceGetCartsNotificationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceGetCartsNotificationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceGetCartsNotificationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceGetCartsNotificationsRequest, a, b);
    }
}
exports.PortalOrderServiceGetCartsNotificationsRequest = PortalOrderServiceGetCartsNotificationsRequest;
PortalOrderServiceGetCartsNotificationsRequest.runtime = protobuf_1.proto3;
PortalOrderServiceGetCartsNotificationsRequest.typeName = "spwn.order.v1.PortalOrderServiceGetCartsNotificationsRequest";
PortalOrderServiceGetCartsNotificationsRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceGetCartsNotificationsResponse
 */
class PortalOrderServiceGetCartsNotificationsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.order.v1.PortalOrderCartNotifications carts = 1;
         */
        this.carts = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceGetCartsNotificationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceGetCartsNotificationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceGetCartsNotificationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceGetCartsNotificationsResponse, a, b);
    }
}
exports.PortalOrderServiceGetCartsNotificationsResponse = PortalOrderServiceGetCartsNotificationsResponse;
PortalOrderServiceGetCartsNotificationsResponse.runtime = protobuf_1.proto3;
PortalOrderServiceGetCartsNotificationsResponse.typeName = "spwn.order.v1.PortalOrderServiceGetCartsNotificationsResponse";
PortalOrderServiceGetCartsNotificationsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "carts", kind: "message", T: portal_common_pb_1.PortalOrderCartNotifications, repeated: true },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceMarkCartNotificationsAsReadRequest
 */
class PortalOrderServiceMarkCartNotificationsAsReadRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string cart_id = 1;
         */
        this.cartId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceMarkCartNotificationsAsReadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceMarkCartNotificationsAsReadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceMarkCartNotificationsAsReadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceMarkCartNotificationsAsReadRequest, a, b);
    }
}
exports.PortalOrderServiceMarkCartNotificationsAsReadRequest = PortalOrderServiceMarkCartNotificationsAsReadRequest;
PortalOrderServiceMarkCartNotificationsAsReadRequest.runtime = protobuf_1.proto3;
PortalOrderServiceMarkCartNotificationsAsReadRequest.typeName = "spwn.order.v1.PortalOrderServiceMarkCartNotificationsAsReadRequest";
PortalOrderServiceMarkCartNotificationsAsReadRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "cart_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.PortalOrderServiceMarkCartNotificationsAsReadResponse
 */
class PortalOrderServiceMarkCartNotificationsAsReadResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalOrderServiceMarkCartNotificationsAsReadResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalOrderServiceMarkCartNotificationsAsReadResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalOrderServiceMarkCartNotificationsAsReadResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalOrderServiceMarkCartNotificationsAsReadResponse, a, b);
    }
}
exports.PortalOrderServiceMarkCartNotificationsAsReadResponse = PortalOrderServiceMarkCartNotificationsAsReadResponse;
PortalOrderServiceMarkCartNotificationsAsReadResponse.runtime = protobuf_1.proto3;
PortalOrderServiceMarkCartNotificationsAsReadResponse.typeName = "spwn.order.v1.PortalOrderServiceMarkCartNotificationsAsReadResponse";
PortalOrderServiceMarkCartNotificationsAsReadResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
//# sourceMappingURL=portal_service_pb.js.map